import React from 'react';
import styles from './Snippet.module.scss';

interface SnippetProps {
  blurb: string;
  highlightText?: string;
}

const emphasize = (text: string, phrase?: string) => {
  if (!phrase) return text;
  try {
    const escaped = phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`(${escaped})`, 'ig');
    return text.split(re).map((part, idx) =>
      re.test(part) ? (
        <mark key={idx} className={styles.highlight}>
          {part}
        </mark>
      ) : (
        <React.Fragment key={idx}>{part}</React.Fragment>
      ),
    );
  } catch {
    return text;
  }
};

const Snippet: React.FC<SnippetProps> = ({ blurb, highlightText }) => {
  return <div className={styles.snippet}>{emphasize(blurb, highlightText)}</div>;
};

export default Snippet;


